import PropTypes from 'prop-types'
import { Table, Tbody, Thead, Tr } from '@chakra-ui/react'
import { numberFormatter } from 'lib'
import { ThMetric, TdMetric } from './common'

export const MetricsAccounting = ({ data }) => {
  return (
    <Table>
      <Thead>
        <Tr>
          <ThMetric w="7%">Department</ThMetric>
          <ThMetric w="7%">Sub Department</ThMetric>
          <ThMetric w="10%">Measure</ThMetric>
          <ThMetric w="10%">Unit of Measure</ThMetric>
          {data.dateHeaders.map(dateHeader => <ThMetric key={dateHeader.date}>{dateHeader.text}</ThMetric>)}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <TdMetric rowSpan={8} colSpan={2}>Accounting</TdMetric>
          <TdMetric rowSpan={2}>Total</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.invoicing.total.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.invoicing.total.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>New Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.invoicing.new.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.invoicing.new.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Pending Invoices</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.invoicing.pendingInvoices.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.invoicing.pendingInvoices.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Final Payment Received Last 7 days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.invoicing.finalPaymentLast7Days.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.invoicing.finalPaymentLast7Days.amount)}</TdMetric>)}
        </Tr>
      </Tbody>
    </Table>
  )
}

MetricsAccounting.propTypes = {
  data: PropTypes.object
}
